export default __webpack_public_path__ + "static/media/contactBanner.193289ab.png";